import { useEffect } from 'react';

interface JsonLdProps {
  data: Record<string, unknown>[];
}

export default function JsonLd({ data }: JsonLdProps) {
  useEffect(() => {
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      document.head.removeChild(el);
    };
  }, [JSON.stringify(data)]);

  return null;
}